import './visio-info.component.ajscss';

import { IAppointmentDeprecatedService } from '@agent/core/contact/appointment-deprecated.service';
import { IContactDeprecatedService } from '@agent/core/contact/contact-deprecated.service';
import { IModificationLog, IVisioAppointmentDetail, IVisioAppointmentUser } from '@commons/models/appointment';
import { IContact } from '@commons/models/contact';
import { IComponentController, IComponentOptions, ILogService } from 'angular';

import { Appointment } from '@contact/upgrade';

import templateUrl from './visio-info.component.html';

const MODULE_NAME = 'cngVisioInfo';

enum ParticipantState {
  ACCEPTED = 'ACCEPTED',
  AWATING = 'AWAITING',
  REFUSED = 'REFUSED',
  NONE = 'NONE',
}

class VisioInfoCtrl implements IComponentController {
  public name = MODULE_NAME;

  responseId: string;

  currentVisioAppointmentDetail: IVisioAppointmentDetail;
  hasVisioAppointmentDetail: boolean = false;
  commentVisio: string;
  commentVisoFirstChar: string;
  participants: IVisioAppointmentUser[];
  awaitingParticipants: IVisioAppointmentUser[];
  refusingParticipants: IVisioAppointmentUser[];
  state: string;
  modifications: IModificationLog[];

  constructor(
    private readonly $log: ILogService,
    private readonly contactDeprecatedService: IContactDeprecatedService,
    private readonly appointmentDeprecatedService: IAppointmentDeprecatedService
  ) {}

  $onInit(): void {
    this.contactDeprecatedService.getContact(this.responseId).then(
      contact => this.initialize(contact),
      error => this.$log.error(error)
    );
  }

  private getStateParticipant(): void {
    if (this.awaitingParticipants !== undefined && this.awaitingParticipants.length > 0) {
      this.state = ParticipantState.AWATING;
    } else if (this.refusingParticipants !== undefined && this.refusingParticipants.length > 0) {
      this.state = ParticipantState.REFUSED;
    } else if (this.participants !== undefined && this.participants.length > 0) {
      this.state = ParticipantState.ACCEPTED;
    } else {
      this.state = ParticipantState.NONE;
    }
  }

  private initialize(contact: IContact): void {
    let resultAppointment: Appointment = contact.appointment!;
    this.appointmentDeprecatedService.searchAppointmentsById(resultAppointment.uuid.trim()).subscribe(
      (result: IVisioAppointmentDetail[]) => {
        let targetAppointments = result;
        this.currentVisioAppointmentDetail = targetAppointments.length > 0 ? targetAppointments[0]! : null!;
        this.hasVisioAppointmentDetail = targetAppointments.length > 0 ? true : false;
        this.commentVisio = this.hasVisioAppointmentDetail ? this.currentVisioAppointmentDetail.comment : '';
        this.commentVisoFirstChar = this.commentVisio !== undefined ? this.commentVisio.substring(0, 19) + '...' : '';
        this.participants = this.hasVisioAppointmentDetail ? this.currentVisioAppointmentDetail.participants : [];
        this.awaitingParticipants = this.hasVisioAppointmentDetail ? this.currentVisioAppointmentDetail.awaitingParticipants : [];
        this.refusingParticipants = this.hasVisioAppointmentDetail ? this.currentVisioAppointmentDetail.refusingParticipants : [];
        this.modifications = this.hasVisioAppointmentDetail ? this.currentVisioAppointmentDetail.modifications : [];

        this.getStateParticipant();
      },
      (error: any) => this.$log.error('[ContactInfo] error in VisioDetailInteraction [' + error + ']'),
      () => {}
    );
  }
}

export class VisioInfo implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  };
  controller = ['$log', 'contactDeprecatedService', 'appointmentDeprecatedService', VisioInfoCtrl];
}

export default MODULE_NAME;
